import { useState } from 'react';

const files = import.meta.glob<string>('./assets/highrise/*.webp', {
  eager: true,
  query: '?url',
  import: 'default',
});

/**
 * 高层建筑火灾场景的示意图。
 *
 * 图片是项目提供的 AI 生成画面，不是真实事故现场照片，也不代表具体建筑或设备状态。
 * 页面不叠加可见图注；替代文字和页面研究声明仍保留来源性质。
 * 图片加载失败时，场景标题与文字内容仍然完整可读。
 */
export function HighriseResearchImage({
  file,
  label,
}: {
  readonly file: string;
  readonly label: string;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  const src = files['./assets/highrise/' + file];
  return (
    <figure className="scc-cap-image scc-hr-image" data-highrise-media={file}>
      {!src || failed === src ? (
        <div className="scc-image-fallback" role="status">
          {label}的示意图未能加载；标题与文字内容仍可阅读。
        </div>
      ) : (
        <img
          src={src}
          alt={label + '，AI生成示意图，非真实事故现场'}
          decoding="async"
          loading="lazy"
          onError={() => setFailed(src)}
        />
      )}
    </figure>
  );
}
